module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('el-card', {
    attrs: {
      "header": "品类管理"
    }
  }, [_c('div', {
    staticStyle: {
      "border-bottom": "0"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("品类管理")])]), _vm._v(" "), _c('el-row', [_c('el-col', [_c('el-button', {
    staticClass: "m-1",
    staticStyle: {
      "margin-bottom": "2%",
      "margin-top": "2%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newCate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增")]), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.data,
      "node-key": "id",
      "default-expand-all": "",
      "expand-on-click-node": false
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {
          staticClass: "m-2"
        }, [_c('img', {
          staticClass: "img-avatar",
          staticStyle: {
            "width": "1rem"
          },
          on: {
            "click": function () { return _vm.getCateConfig(data); }
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(data.categoryName))]), _vm._v(" "), _c('span', [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "medium"
          },
          on: {
            "click": function () { return _vm.edit(data, '编辑品类'); }
          }
        }, [_vm._v("编辑 "), _c('i', {
          staticClass: "el-icon-edit-outline"
        })]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (node.level === 1),
            expression: "node.level === 1"
          }],
          attrs: {
            "type": "text",
            "size": "medium"
          },
          on: {
            "click": function () { return _vm.append(node, data, '新增品类'); }
          }
        }, [_vm._v(" 新增"), _c('i', {
          staticClass: "el-icon-plus"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "medium"
          },
          on: {
            "click": function () { return _vm.remove(node, data, '删除品类'); }
          }
        }, [_vm._v(" 删除"), _c('i', {
          staticClass: "el-icon-delete"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "medium"
          },
          on: {
            "click": function () { return _vm.toPro(data); }
          }
        }, [_vm._v("查看商品"), _c('i', {
          staticClass: "el-icon-search"
        })])], 1)])
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑分类详情",
      "visible": _vm.cateEditModel,
      "width": "60%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cateEditModel = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "10px"
    }
  }, [_c('el-card', {
    staticStyle: {
      "margin": "1rem",
      "text-align": "left"
    },
    attrs: {
      "header": '分类信息[' + _vm.CateName + ']'
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "src": _vm.imageUrl
    }
  }), _vm._v(" "), _c('b-form-file', {
    attrs: {
      "plain": true,
      "multiple": true,
      "center": ""
    },
    model: {
      value: (_vm.image),
      callback: function($$v) {
        _vm.image = $$v
      },
      expression: "image"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-card', {
    attrs: {
      "header": '分类优先级'
    }
  }, [_c('el-slider', {
    attrs: {
      "show-input": "",
      "show-stops": "",
      "max": 10
    },
    model: {
      value: (_vm.selectCate.Node.Data.Index),
      callback: function($$v) {
        _vm.$set(_vm.selectCate.Node.Data, "Index", $$v)
      },
      expression: "selectCate.Node.Data.Index"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin": "1rem",
      "text-align": "left"
    }
  }, [_c('el-card', [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("其他配置")]), _vm._v(" "), _c('el-button', {
    staticClass: "m-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDomain
    }
  }, [_vm._v("新增配置")])], 1), _vm._v(" "), _c('el-form', {
    ref: "dynamicValidateForm",
    attrs: {
      "model": _vm.dynamicValidateForm
    }
  }, _vm._l((_vm.dynamicValidateForm.domains), function(domain, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "prop": 'domains.' + index + '.value',
        "rules": {
          required: true,
          message: '配置不能为空',
          trigger: 'blur'
        }
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入新的配置"
      },
      model: {
        value: (domain.key),
        callback: function($$v) {
          _vm.$set(domain, "key", $$v)
        },
        expression: "domain.key"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 14
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入新的配置内容"
      },
      model: {
        value: (domain.value),
        callback: function($$v) {
          _vm.$set(domain, "value", $$v)
        },
        expression: "domain.value"
      }
    })], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDomain(domain)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cateEditModel = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.updateCate(_vm.selectCate);
        _vm.updateCateConfig(_vm.selectCate.Node);
        _vm.cateEditModel = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f33e1fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/product/Cate.vue
// module id = 1063
// module chunks = 2